export const environment = {
  apiHostStartPoint: process.env.REACT_APP_API_URL,
  apiHostVersion: '/api/',
  marketingUrl: process.env.REACT_APP_MARKETING_URL,
};
